module.exports = __webpack_public_path__ + "media/images/matchdaySelector__md1--selected-0ad651cde69168a72a194b8e779f0f46.png";